import { useContext } from "react";
import {
    HseInstanceContext,
    type HseInstanceContextValue,
} from "@dashboard/contexts/hseInstanceContext";

export function useHseInstance(): HseInstanceContextValue {
    const context = useContext(HseInstanceContext);
    if (!context) {
        throw new Error("useHseInstance must be used within a HseInstanceProvider");
    }
    return context;
}
